import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { HttpServiceHelper } from '@reg/shared/service';
import { IdentitySport } from '@reg/shared/model';
import { IJsonApiResponse } from '@reg/shared/json-api/json-api.interface';
import { observableInSeparateThread } from '@reg/shared/helper/observable-helper';

/**
 * Service to get Sports
 */
@Injectable()
export class IdentitySportService {
    private identityApiBaseUrl: string;
    private cachedSportMap: { [apiRequest: string]: IdentitySport[]; } = {};

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
        this.identityApiBaseUrl = http.configService.getBaseConfig('identityApiBaseUrl');
    }

    /**
     * Get all Sports
     */
    public getIndex(forceRefresh: boolean = false): Observable<IdentitySport[]> {
        const apiUrl: string = `${this.identityApiBaseUrl}/sports/`;

        if (!forceRefresh &&
            this.cachedSportMap[apiUrl]) {
            // if `cachedSports` is available just return it as `Observable`
            return observableInSeparateThread(this.cachedSportMap[apiUrl]);
        }
        // Make the http request
        return this.http.get(apiUrl).pipe(map((response: IJsonApiResponse) => {
            const sports: IdentitySport[] = [];

            const bodyData: any = response.data || [];
            for (const sport of bodyData) {
                sports.push((new IdentitySport()).deserialize(sport));
            }

            this.cachedSportMap[apiUrl] = sports;
            return sports;
        }));
    }
}
